import type { PrepareCardId } from '../wf-constants'

const PREPARE_CARD_SOURCE_KEY = 'prepareCardSource'
const TTL_MS = 2 * 60 * 60 * 1000

interface StoredCardSource {
  cardId: PrepareCardId
  timestamp: number
}

export function setPrepareCardSource(cardId: PrepareCardId): void {
  const value: StoredCardSource = { cardId, timestamp: Date.now() }
  sessionStorage.setItem(PREPARE_CARD_SOURCE_KEY, JSON.stringify(value))
}

/**
 * Returns true if the stored card source matches the given cardId and is within the TTL.
 * Always clears the stored value to prevent stale attribution.
 */
export function consumePrepareCardSource(cardId: PrepareCardId): boolean {
  const raw = sessionStorage.getItem(PREPARE_CARD_SOURCE_KEY)
  sessionStorage.removeItem(PREPARE_CARD_SOURCE_KEY)
  if (!raw) return false

  try {
    const stored: StoredCardSource = JSON.parse(raw)
    return stored.cardId === cardId && Date.now() - stored.timestamp < TTL_MS
  } catch {
    return false
  }
}
